<template>
  <div class="page-header-index-wide">
    <a-card :bordered="false" :bodyStyle="{ padding: '16px 0', height: '100%' }" :style="{ height: '100%' }">
      <div class="account-settings-info-main" :class="device">
        <div class="account-settings-info-left">
          <a-menu
            :mode="device == 'mobile' ? 'horizontal' : 'inline'"
            :style="{ border: '0', width: device == 'mobile' ? '560px' : 'auto'}"
            :defaultSelectedKeys="defaultSelectedKeys"
            type="inner"
            @openChange="onOpenChange"
          >
            <a-menu-item key="/system/base/account">
              <router-link :to="{ name: 'Account' }">
                账号信息
              </router-link>
            </a-menu-item>
            <a-menu-item key="/system/base/system">
              <router-link :to="{ name: 'System' }">
                企业信息
              </router-link>
            </a-menu-item>
            <!-- <a-menu-item key="/system/base/oss">
              <router-link :to="{ name: 'Oss' }">
                阿里云OSS配置
              </router-link>
            </a-menu-item> -->
            <!-- <a-menu-item key="/system/base/sms">
              <router-link :to="{ name: 'Sms' }">
                短信配置
              </router-link>
            </a-menu-item> -->
            <!-- <a-menu-item key="/system/base/wxapp">
              <router-link :to="{ name: 'Wxapp' }">
                微信小程序配置
              </router-link>
            </a-menu-item>
            <a-menu-item key="/system/base/pagenow">
              <router-link :to="{ name: 'Pagenow' }">
                数据大屏配置
              </router-link>
            </a-menu-item> -->
          </a-menu>
        </div>
        <div class="account-settings-info-right">
          <!-- <div class="account-settings-info-title">
            <span>{{ $route.meta.title }}</span>
          </div> -->
          <route-view></route-view>
        </div>
      </div>
    </a-card>
  </div>
</template>

<script>
// import _ from 'lodash'
import { PageView, RouteView } from '@/layouts'
import { mixinDevice } from '@/utils/mixin.js'

export default {
  components: {
    RouteView,
    PageView
  },
  mixins: [mixinDevice],
  data () {
    return {
      // horizontal  inline
      mode: 'inline',
      openKeys: [],
      defaultSelectedKeys: [],
      pageTitle: ''
    }
  },
  created () {
    this.updateMenu()
    // this.getSetting()
  },
  methods: {
    onOpenChange (openKeys) {
      this.openKeys = openKeys
    },
    updateMenu () {
      const routes = this.$route.matched.concat()
      this.defaultSelectedKeys = [ routes.pop().path ]
    }
  }
}
</script>

<style lang="less" scoped>
  .account-settings-info-main {
    width: 100%;
    display: flex;
    height: 100%;
    overflow: auto;

    &.mobile {
      display: block;

      .account-settings-info-left {
        border-right: unset;
        border-bottom: 1px solid #e8e8e8;
        width: 100%;
        height: 50px;
        overflow-x: auto;
        overflow-y: scroll;
      }
      .account-settings-info-right {
        padding: 20px 40px;
      }
    }

    .account-settings-info-left {
      border-right: 1px solid #e8e8e8;
      width: 224px;
    }

    .account-settings-info-right {
      flex: 1 1;
      padding: 8px 40px;

      .account-settings-info-title {
        color: rgba(0,0,0,.85);
        font-size: 20px;
        font-weight: 500;
        line-height: 28px;
        margin-bottom: 12px;
      }
      .account-settings-info-view {
        padding-top: 12px;
      }
    }
  }
</style>
